import CustomerType from '@/contact/constants/CustomerType';
import VehicleStatus from '@/dossier/constants/VehicleStatus';
import WorkStatus from '@/dossier/constants/WorkStatus';
import i18n from '@/general/i18n';
import RimType from '@/tires/constants/RimType';
import Language from '../constants/Language';
import Severity from '../constants/Severity';
import VehicleType from '../constants/VehicleType';
import { Nullish } from './typescript';

export function getCustomerTypeLabel(type: CustomerType): string {
  switch (type) {
    case CustomerType.OWNER:
      return i18n.global.t('customerType.owner');
    case CustomerType.COMPANY:
      return i18n.global.t('customerType.company');
    case CustomerType.DRIVER:
      return i18n.global.t('customerType.driver');
  }
}

export function getSeverityLabel(severity: Severity): string {
  switch (severity) {
    case Severity.GOOD:
      return i18n.global.t('severity.good');
    case Severity.CAUTION:
      return i18n.global.t('severity.caution');
    case Severity.BAD:
      return i18n.global.t('severity.bad');
  }
}

export function getVehicleStatusLabel(status: VehicleStatus): string {
  switch (status) {
    case VehicleStatus.EXPECTED:
      return i18n.global.t('vehicleStatus.expected');
    case VehicleStatus.CHECKED_IN:
      return i18n.global.t('vehicleStatus.checkedIn');
    case VehicleStatus.CHECKED_IN_NEW:
      return i18n.global.t('vehicleStatus.checkedInNew');
    case VehicleStatus.READY_FOR_PICKUP:
      return i18n.global.t('vehicleStatus.readyForPickup');
    case VehicleStatus.PICKED_UP:
      return i18n.global.t('vehicleStatus.pickedUp');
  }
}

export function getWorkStatusLabel(status: WorkStatus): string {
  switch (status) {
    case WorkStatus.NOT_STARTED:
      return i18n.global.t('workStatus.notStarted');
    case WorkStatus.BEING_HANDLED:
      return i18n.global.t('workStatus.beingHandled');
    case WorkStatus.ON_HOLD:
      return i18n.global.t('workStatus.onHold');
    case WorkStatus.TECH_READY:
      return i18n.global.t('workStatus.techReady');
    case WorkStatus.WORK_READY:
      return i18n.global.t('workStatus.workReady');
  }
}

export function getLanguageLabel(language: Language): string {
  switch (language) {
    case Language.NL:
      return i18n.global.t('language.nl');
    case Language.EN:
      return i18n.global.t('language.en');
    case Language.DE:
      return i18n.global.t('language.de');
    case Language.FR:
      return i18n.global.t('language.fr');
  }
}

export function getVehicleTypeLabel(type: Nullish<VehicleType>): string {
  switch (type) {
    case VehicleType.CAR:
      return i18n.global.t('vehicleType.car');
    case VehicleType.BICYCLE:
      return i18n.global.t('vehicleType.bicycle');
    case VehicleType.MOTORCYCLE:
      return i18n.global.t('vehicleType.motorcycle');
    case VehicleType.EXCAVATOR:
      return i18n.global.t('vehicleType.excavator');
    default:
      return '';
  }
}

export function getRimTypeLabel(type: RimType): string {
  switch (type) {
    case RimType.NOT_ON_RIM:
      return i18n.global.t('rimType.notOnRim');
    case RimType.STEEL:
      return i18n.global.t('rimType.steel');
    case RimType.ALUMINIUM:
      return i18n.global.t('rimType.aluminium');
  }
}